import React from "react";
import { Box, Button } from "@mui/material";
import "./index.css";
import { Collection } from "../../types";
import { useAppDispatch } from "../../stores/store";
import HeadLine from "../HeadLine";
import CollectionForm from "./CollectionForm";
import RunsBox from "./RunsBox";
import CollectionSummaryTable from "./CollectionSummaryTable";
import {
  goToNextCollection,
  goToPreviousCollection,
} from "../../stores/collection";

interface props {
  collection: Collection;
  goToCollection: () => void;
  curIndex: number;
  collectionCount: number;
}

const CollectionDetail: React.FC<props> = ({
  collection,
  goToCollection,
  curIndex,
  collectionCount,
}) => {
  const dispatch = useAppDispatch();

  return (
    <Box className={"collection-detail"}>
      <HeadLine
        value={collection.displayName + ""}
        handleGoBack={
          curIndex === 0
            ? undefined
            : () => {
                dispatch(goToPreviousCollection());
              }
        }
        handleGoNext={
          curIndex === collectionCount - 1
            ? undefined
            : () => {
                dispatch(goToNextCollection());
              }
        }
        showNav={true}
      />
      <div className="button-view-specimens">
        <Button variant="contained" onClick={goToCollection}>
          View Specimens
        </Button>
      </div>
      <CollectionForm collection={collection} />
      <RunsBox runs={collection.runs} />
      <CollectionSummaryTable
        collectionId={collection?.id}
        collection={collection}
      />
    </Box>
  );
};

export default CollectionDetail;
